<template>
  <div class="spacial-volumeDialog">
    <el-dialog :title="title" :visible.sync="volumeDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="volumeForm" :model="volumeForm"  label-width="140px" :rules="rules">

        <!-- <el-form-item label="所属学段"  class="is-required"  prop="stageId" v-if="!this.$props.id">
          <el-select v-model="volumeForm.stageId"  placeholder="请选择" @change="changeit">
            <el-option :label="item.name" :value="item.id"   v-for="(item,index ) in stages"  :key="index" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属科目"  class="is-required"  prop="subjectId"  v-if="!this.$props.id">
          <el-select v-model="volumeForm.subjectId"  placeholder="请选择" @change="changeSubject">
            <el-option :label="item.name" :value="item.id"   v-for="(item,index ) in subjects"  :key="index" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属版本"  class="is-required"  prop="versionId"  v-if="!this.$props.id">
          <el-select v-model="volumeForm.versionId"  placeholder="请选择">
            <el-option :label="item.name" :value="item.id"   v-for="(item,index ) in versions"  :key="index" ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="册别名称"  class="is-required" prop="name" >
          <el-input v-model.trim="volumeForm.name" maxlength="32" placeholder="请输入册别名称"> </el-input>
        </el-form-item>
        <el-form-item label="排序值"  class="is-required" prop="ordinal">
          <el-input v-model.trim="volumeForm.ordinal" placeholder="请输入学排序值..." maxlength="9"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="decription">
          <el-input v-model.trim="volumeForm.description" maxlength="100" placeholder="请输入描述"> </el-input>
        </el-form-item>
        <el-form-item label="适用模块"  class="is-required"  prop="specifyModuleId">
          <el-select v-model="volumeForm.specifyModuleId"  placeholder="请选择">
              <template v-for="item in moduleList">
                <el-option :key="item.id" :label="item.name" :value="item.id" v-if="!item.disabled && !item.hide"></el-option>
              </template>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="volumeDialogVisible = false">关闭</el-button>
        <el-button type="primary"  @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import volumeService from '@/service/volumeService'
import commonService from '@/service/commonService'
export default {
  props: {
    id: {
      type: Number
    },
    versionId: Number,
    specifyModuleId: Number | String,
    moduleList: Array,
    rowData: Object,
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      title: '新增册别',
      loading: false,
      stages: [],
      subjects: [],
      versions: [],
      volumeForm: {
        id: '',
        name: '',
        description: '',
        versionId: 0,
        ordinal: '',
        specifyModuleId: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入册别名称', trigger: ['blur', 'change']}
        ],
        stageId: [
          {required: true, message: '请选择学段', trigger: ['blur', 'change']}
        ],
        subjectId: [
          {required: true, message: '请选择科目', trigger: ['blur', 'change']}
        ],
        versionId: [
          {required: true, message: '请选择版本', trigger: ['blur', 'change']}
        ],
        specifyModuleId: [
          {required: true, message: '请选择适用模块', trigger: ['blur', 'change']}
        ],
        ordinal: [
          {required: true, message: '请输入序列号', trigger: 'blur'},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: ['blur', 'change']}
        ]
      },
    }
  },
  async mounted () {
    await this.fetchLearnData()
    await this.fetchClassData()
    await this.fetchVersionData()
  },
  methods: {
    async changeit () {
      await this.fetchClassData()
      await this.fetchVersionData()
    },
    async changeSubject () {
      await this.fetchVersionData()
    },
    /* 获取学段数据 */
    async fetchLearnData () {
      try {
        let data = await commonService.fetchCommonStage()
        if (data) {
          this.volumeForm.stageId = data[0].id
          this.stages = data
        } else {
          this.stages = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取科目数据 */
    async fetchClassData () {
      try {
        let data = await commonService.fetchCommonSubject(parseInt(this.volumeForm.stageId))
        if (data && data.length > 0) {
          this.volumeForm.subjectId = data[0].id
          this.subjects = data
        } else {
          this.stages = []
          this.subjects = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取版本数据 */
    async fetchVersionData () {
      try {
        let data = await commonService.fetchCommonVersion(parseInt(this.volumeForm.subjectId))
        if (data && data.length > 0) {
          this.volumeForm.versionId = data[0].id
          this.versions = data
        } else {
          this.stages = []
          this.subjects = []
          this.versions = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    save () {
      this.loading = true
      this.$refs.volumeForm.validate(async valid => {
        if (valid) {
          try {
            await volumeService.save(this.volumeForm)
            // 重置表单
            // this.$refs.volumeForm.resetFields()
            Object.keys(this.volumeForm).forEach(key => this.volumeForm[key] = '')
            this.$emit('success')
            this.loading = false
            this.volumeDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    volumeDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.volumeForm) {
          // this.$refs.volumeForm.resetFields()
          Object.keys(this.volumeForm).forEach(key => this.volumeForm[key] = '')
        }
        // 加载初始化数据
        if (this.$props.id) {
          this.title = '编辑册别'
          this.volumeForm = {
            id: this.$props.id,
            name: this.$props.rowData.name,
            description: this.$props.rowData.description,
            versionId: this.$props.rowData.versionId,
            ordinal: this.$props.rowData.ordinal,
            specifyModuleId: this.$props.rowData.specifyModuleId,
          }
        } else {
          this.volumeForm.name = ''
          this.volumeForm.versionId = this.$props.versionId
          this.volumeForm.specifyModuleId = this.$props.specifyModuleId
          this.volumeForm.decription = ''
          this.title = '新增册别'
        }
      }
    }
  },
  computed: {
    volumeDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
  .spacial-volumeDialog .el-form-item:nth-child(4) .el-input,.spacial-volumeDialog .el-form-item:nth-child(5) .el-input{
      width:70%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/special-volume-manage/edit-dialog/index.vue